import React, { useEffect } from 'react';
import useDataStore from '../../stores/useDataStore';

const MoodleCourses = () => {
  const { moodleCourses, getMoodleCourses, loading, error } = useDataStore();

  useEffect(() => {
    getMoodleCourses();
  }, []);


  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Moodle Courses</h1>
      {loading && (
        <div className="flex justify-center items-center py-10">
          <span className="loader"></span>
        </div>
      )}

      {error && <p className="text-red-500">Error: {error}</p>}

      {!loading && moodleCourses.length === 0 && (
        <p className="text-gray-500">No courses found.</p>
      )}

      {!loading && moodleCourses.length > 0 && (
        <table className="min-w-full  border-gray-200 border-collapse">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-4 py-2 border">#</th>
              <th className="px-4 py-2 border">Course Name</th>
              <th className="px-4 py-2 border">Course ID</th>
            </tr>
          </thead>
          <tbody>
            {moodleCourses.map((course, index) => (
              <tr key={course.id} className="text-center">
                <td className="px-4 py-2 border">{index + 1}</td>
                <td className="px-4 py-2 border">{course?.fullname}</td>
                <td className="px-4 py-2 border">{course?.id}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default MoodleCourses;
